<template>
  <div class="technopaws">
    <TechnopawsHeader />
    <MeetPawPulse />
    <TheKeyOfSuccess />
    <OurServices @scrollToService="scrollToService" />
    
    <!-- Secciones de servicios específicos -->
    <section id="pawpulse-service" class="service-section">
      <PawpulseServiceSection />
    </section>
    
    <section id="outsourcing-service" class="service-section">
      <OutsourcingServiceSection />
    </section>
    
    <section id="consultancy-service" class="service-section">
      <ConsultancyServiceSection />
    </section>
    
    <ContactUs />
  </div>
</template>

<script>
import TechnopawsHeader from '@/components/technopawsLanding/TechnopawsHeader.vue'
import MeetPawPulse from '@/components/technopawsLanding/MeetPawPulse.vue' 
import TheKeyOfSuccess from '@/components/technopawsLanding/TheKeyOfSuccess.vue'
import OurServices from '@/components/technopawsLanding/OurServices.vue'
import PawpulseServiceSection from '@/components/technopawsLanding/PawpulseServiceSection.vue'
import OutsourcingServiceSection from '@/components/technopawsLanding/OutsourcingServiceSection.vue'
import ConsultancyServiceSection from '@/components/technopawsLanding/ConsultancyServiceSection.vue'
import ContactUs from '@/components/technopawsLanding/ContactUs.vue'
import { setTawkAttributes } from '@/utils/tawk'


export default {
  name: 'TechnopawsView',
  components: {
    TechnopawsHeader,
    MeetPawPulse,
    TheKeyOfSuccess,
    OurServices,
    PawpulseServiceSection,
    OutsourcingServiceSection,
    ConsultancyServiceSection,
    ContactUs
  },
  mounted() {
    // Configurar atributos de tawk.to para la vista 'landing'
    setTawkAttributes('landing')
  },
  methods: {
    scrollToService(serviceId) {
      const element = document.getElementById(serviceId + '-service');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}

</script>

<style scoped>
/* Añadiendo comportamiento de scroll suave para toda la página */
:root {
  scroll-behavior: smooth;
  /* Añadimos padding superior para el scroll igual a la altura del header */
  scroll-padding-top: 80px;
}

.technopaws {
  min-height: 100vh;
}

.header {
  background-color: #09405c;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  flex-shrink: 0;
}

.logo-img {
  height: 40px;
  width: auto;
}

.desktop-menu {
  margin-left: 2rem;
}

.nav-links {
  display: flex;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #4db5ff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links a {
  color: white;
  font-size: 1.2rem;
  transition: color 0.3s;
}

.social-links a:hover {
  color: #4db5ff;
}

.register-btn {
  background-color:hsl(205, 100.00%, 65.10%);
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.register-btn:hover {
  background-color: #3994dd;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
}

.mobile-menu-btn span {
  display: block;
  width: 24px;
  height: 2px;
  background-color: white;
  position: relative;
  transition: background-color 0.3s;
}

.mobile-menu-btn span::before,
.mobile-menu-btn span::after {
  content: '';
  position: absolute;
  width: 24px;
  height: 2px;
  background-color: white;
  transition: transform 0.3s;
}

.mobile-menu-btn span::before {
  top: -6px;
}

.mobile-menu-btn span::after {
  bottom: -6px;
}

.mobile-menu-btn span.open {
  background-color: transparent;
}

.mobile-menu-btn span.open::before {
  transform: rotate(45deg) translate(4px, 6px);
}

.mobile-menu-btn span.open::after {
  transform: rotate(-45deg) translate(4px, -6px);
}

.mobile-menu {
  display: none;
  position: fixed;
  top: 72px;
  left: 0;
  width: 100%;
  height: calc(100vh - 72px);
  background-color: #09405c;
  padding: 2rem;
  transform: translateX(100%);
  transition: transform 0.3s;
}

.mobile-menu.open {
  transform: translateX(0);
}

.mobile-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu li {
  margin-bottom: 1.5rem;
}

.mobile-menu a {
  color: white;
  text-decoration: none;
  font-size: 1.2rem;
  display: block;
}

.mobile-social {
  margin: 2rem 0;
}

.register-btn.mobile {
  width: 100%;
  padding: 1rem;
}

@media (max-width: 1024px) {
  .desktop-menu,
  .header-right {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-menu {
    display: block;
  }
}
.service-section {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .service-section {
    min-height: auto;
  }
}
</style>